module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no":"No","value":"Value","yes":"Yes"},"fr":{"no":"Non","value":"Valeur","yes":"Oui"}}')
  delete Component.options._Ctor
}
